import { gql } from "@apollo/client"

export const ProductListingFragment = gql`
  fragment ProductListingFragment on Cart {
    id
    # eslint-disable-next-line @graphql-eslint/require-id-when-available
    items {
      uid
      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      select_product_image
      product {
        uid
        name
        sku
        url_key
        thumbnail {
          url
        }
        small_image {
          url
        }
        presale_product {
          status
          label
          note
          shipping_to
          shipping_from
        }
        stock_status
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        ... on ConfigurableProduct {
          variants {
            attributes {
              uid
              code
              value_index
            }
            # eslint-disable-next-line @graphql-eslint/require-id-when-available
            product {
              uid
              sku
              thumbnail {
                url
              }
              presale_product {
                status
                label
                note
                shipping_to
                shipping_from
              }
              stock_status
              media_gallery {
                disabled
                label
                position
                url
              }
            }
          }
        }
        ... on ConfigurableProduct {
          configurable_options {
            attribute_code
            attribute_id
            uid
            label
            # eslint-disable-next-line @graphql-eslint/require-id-when-available
            values {
              uid
              default_label
              label
              store_label
              use_default_value
              value_index
              swatch_data {
                ... on ImageSwatchData {
                  thumbnail
                }
                value
              }
            }
          }
        }
      }
      prices {
        price {
          currency
          value
        }
        row_total {
          value
        }
        total_item_discount {
          value
        }
      }
      quantity
      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      ... on ConfigurableCartItem {
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        configurable_options {
          id
          configurable_product_option_uid
          option_label
          configurable_product_option_value_uid
          value_label
          value_id
          __typename
        }
      }
    }
  }
`
